import React from 'react';
import { Link } from 'react-router-dom';
import { getIcon, ICON_OPTIONS } from '../../lib/icons';
import { EField, FieldRow } from './EditableField';

export default function SectionPricing({
  section_label = '', title = '', badge_text = '', amount = '', amount_label = '', features = [], cta_text = '', cta_url = '/', guarantee_text = '',
  mode = 'view', onChange,
}) {
  const set = (k) => (v) => onChange?.({ [k]: v });
  const upd = (i, k, v) => onChange?.({ features: features.map((f, idx) => idx === i ? { ...f, [k]: v } : f) });
  const add = () => onChange?.({ features: [...features, { icon: 'check-circle', text: 'New benefit' }] });
  const rem = (i) => onChange?.({ features: features.filter((_, idx) => idx !== i) });
  return (
    <section className="py-24 bg-ee-bg2 relative">
      <div className="ee-container max-w-3xl">
        <div className="text-center mb-12">
          {mode === 'edit' ? (
            <>
              <FieldRow label="Section Label"><EField value={section_label} onChange={set('section_label')} mode={mode} /></FieldRow>
              <FieldRow label="Title"><EField value={title} onChange={set('title')} mode={mode} /></FieldRow>
            </>
          ) : (
            <>
              <div className="text-xs tracking-[0.3em] text-gold mb-3 uppercase">{section_label}</div>
              <h2 className="hero-title text-4xl md:text-5xl text-white">{title}</h2>
            </>
          )}
        </div>
        <div className="ee-card p-10 relative overflow-hidden" style={{ boxShadow: '0 0 60px -20px rgba(196,161,68,0.35)' }}>
          <div className="absolute -top-1 left-1/2 -translate-x-1/2 px-4 py-1 rounded-b-md gold-grad text-black text-xs font-semibold uppercase tracking-widest">
            <EField value={badge_text} onChange={set('badge_text')} mode={mode} />
          </div>
          <div className="text-center pt-6 pb-8 border-b border-ee-border">
            <div className="flex items-baseline justify-center gap-2">
              <span className="text-5xl md:text-6xl text-gold font-serif"><EField value={amount} onChange={set('amount')} mode={mode} /></span>
              <span className="text-ee-muted text-sm"><EField value={amount_label} onChange={set('amount_label')} mode={mode} /></span>
            </div>
          </div>
          <ul className="py-8 space-y-4">
            {features.map((f, i) => {
              const Icon = getIcon(f.icon);
              return (
                <li key={i} className="flex items-start gap-3">
                  <span className="mt-0.5 w-6 h-6 rounded-full bg-gold/15 border border-gold/40 flex items-center justify-center flex-shrink-0"><Icon size={12} className="text-gold" /></span>
                  <span className="text-ee-text2 flex-1"><EField value={f.text} onChange={(v) => upd(i, 'text', v)} mode={mode} /></span>
                  {mode === 'edit' && (
                    <>
                      <select value={f.icon} onChange={(e) => upd(i, 'icon', e.target.value)} className="text-xs bg-ee-card2 border border-gold/30 rounded px-2 py-0.5 text-white">
                        {ICON_OPTIONS.map(o => <option key={o} value={o}>{o}</option>)}
                      </select>
                      <button onClick={() => rem(i)} className="text-xs text-red-400">x</button>
                    </>
                  )}
                </li>
              );
            })}
          </ul>
          {mode === 'edit' && <button onClick={add} className="text-xs px-3 py-1.5 rounded border border-gold/40 text-gold mb-6">+ Feature</button>}
          {mode === 'edit' ? (
            <div className="grid grid-cols-2 gap-2 mb-4">
              <FieldRow label="CTA Text"><EField value={cta_text} onChange={set('cta_text')} mode={mode} /></FieldRow>
              <FieldRow label="CTA URL"><EField value={cta_url} onChange={set('cta_url')} mode={mode} /></FieldRow>
              <FieldRow label="Guarantee Text"><EField value={guarantee_text} onChange={set('guarantee_text')} mode={mode} /></FieldRow>
            </div>
          ) : (
            <>
              <Link to={cta_url || '/'} className="block text-center w-full py-4 rounded-md gold-grad text-black font-semibold shadow-lg shadow-gold/20 hover:shadow-gold/40 transition-all hover:-translate-y-0.5">{cta_text}</Link>
              <div className="text-center text-xs text-ee-muted mt-4">{guarantee_text}</div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
